import './App.scss';
import { Route, BrowserRouter as Router } from "react-router-dom";
import Home from './components/home/Home';
import './styles/mixins/global.scss';
import Header from './components/Auth/Header/Header';
import Footer from './components/Auth/Footer/Footer';
function App() {
  return (
    <>
      <Router>
        <Header/>
        <Route exact path="/" component={Home}/>
        <Footer/>
      </Router>
    </>
  );
}

export default App;
